import { render, staticRenderFns } from "./StatsShiftConfig.vue?vue&type=template&id=06a77984"
import script from "./StatsShiftConfig.vue?vue&type=script&lang=js"
export * from "./StatsShiftConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports